import React from "react"
import { Link } from "gatsby"

const Footer: React.FC = () => {
  return (
    <footer
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "1rem",
      }}
    >
      <div style={{ display: "flex", gap: "1.25rem", alignItems: "center" }}>
        <Link to="/">Home</Link>
        <Link to="/contact">Contact</Link>
        <a
          href="https://www.github.com/AyemunHossain"
          target="_blank"
          rel="noopener noreferrer"
        >
          GitHub
        </a>
        <a
          href="https://www.linkedin.com/in/ayemunh/"
          target="_blank"
          rel="noopener noreferrer"
        >
          LinkedIn
        </a>
      </div>
      <span
        style={{
          fontSize: "0.72rem",
          letterSpacing: "1px",
          color: "var(--textDim)",
          textTransform: "uppercase",
        }}
      >
        © Ayemun Hossain · MIT
      </span>
    </footer>
  )
}

export default Footer
